import { http } from './http';

const controller = 'edoc/document-timelines';

export const getDocumentLog = async (documentId) =>
  await http.get(`${controller}/get-logs`, {
    params: { documentId }
  });
